import {Trans} from '@lingui/macro';
import React, {FC, useState} from 'react';

import {HandlerOf} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {buildSettingsPath} from '../../models/url/settingsUrlHelpers';
import {SettingsResourcePagesEnum, SettingsSignaturesUrl} from '../../models/url/settingsUrlModel';
import {SettingsContentHeader} from '../common/settingsContentHeader';
import {StyledSettingsContent, StyledSettingsMain, StyledSettingsWrapper} from '../common/settingsWrapper';
import {SettingsHeader} from '../settingsHeader';
import {SignaturesTableContainer} from './table/signaturesTableContainer';

/*
 * Props.
 */

interface SettingsSignaturesListProps {
  signaturesUrl: SettingsSignaturesUrl;
  navigateToLink: HandlerOf<string>;
}

/*
 * Component.
 */

export const SettingsSignaturesList: FC<SettingsSignaturesListProps> = (props) => {
  const {signaturesUrl, navigateToLink} = props;
  const [searchQuery, setSearchQuery] = useState('');

  const onSearchQueryChange = (newQuery: string) => {
    setSearchQuery(newQuery);
  };

  const renderHeaderButton = (buttonProps: React.ComponentProps<typeof Button>) => (
    <Button
      {...buttonProps}
      variant={ButtonVariantsEnum.PRIMARY}
      onClick={() =>
        navigateToLink(buildSettingsPath({...signaturesUrl, resourcePage: SettingsResourcePagesEnum.NEW}))
      }
    >
      <Trans id="settings-signatures-addasignature">Add a signature</Trans>
    </Button>
  );

  return (
    <StyledSettingsWrapper>
      <SettingsHeader>
        <Trans id="settings-signatures-header">Signatures</Trans>
      </SettingsHeader>
      <StyledSettingsMain>
        <StyledSettingsContent>
          <SettingsContentHeader
            searchInputValue={searchQuery}
            onSearchInput={onSearchQueryChange}
            onExitClick={() => {
              setSearchQuery('');
            }}
            renderButtons={renderHeaderButton}
          />
          <SignaturesTableContainer signaturesUrl={signaturesUrl} searchQuery={searchQuery} />
        </StyledSettingsContent>
      </StyledSettingsMain>
    </StyledSettingsWrapper>
  );
};
